import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2526e44e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ICMS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "BC do ICMS"
}, "BC do ICMS", -1))
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ICMS ST"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "IPI"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "BC do IPI"
}, "BC do IPI", -1))
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Importação"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_32 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_33 = { class: "ant-row" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_35 = { class: "ant-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "PIS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "BC do PIS"
}, "BC do PIS", -1))
const _hoisted_41 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "COFINS"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "BC do COFINS"
}, "BC do COFINS", -1))
const _hoisted_49 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_50 = { class: "ant-row" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_52 = { class: "ant-row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Desoneração"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_55 = { class: "ant-row" }
const _hoisted_56 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_58 = { class: "ant-row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-div-titulo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "A. Tributos"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-divider ant-divider-vertical ss-div-separador ss-ocultar-mobile",
    role: "separator"
  })
], -1))
const _hoisted_60 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_61 = { class: "ant-row" }
const _hoisted_62 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                          label: _withCtx(() => [
                            _hoisted_8,
                            _createVNode(_component_a_popover, {
                              placement: "top",
                              title: "Incidência na Base de Cálculo ICMS"
                            }, {
                              content: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedIncidenciasCalculo, (incidencia, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: incidencia.incidencia + index
                                  }, [
                                    (incidencia.incidencia === 'ICMS')
                                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                          key: 0,
                                          style: {"margin-left":"0px!important"},
                                          checked: incidencia.valor,
                                          "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.totalAlterado()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacoes-fp"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoIcmsTotal,
                              "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedImpostos.baseCalculoIcmsTotal) = $event)),
                              onValorDigitado: _cache[2] || (_cache[2] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do ICMS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorIcmsTotal,
                              "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedImpostos.valorIcmsTotal) = $event)),
                              onValorDigitado: _cache[4] || (_cache[4] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_form_item, {
                          label: "BC do ICMS ST",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoIcmsSubstituicaoTotal,
                              "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedImpostos.baseCalculoIcmsSubstituicaoTotal) = $event)),
                              onValorDigitado: _cache[6] || (_cache[6] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do ICMS ST",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorIcmsSubstituicaoTotal,
                              "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.computedImpostos.valorIcmsSubstituicaoTotal) = $event)),
                              onValorDigitado: _cache[8] || (_cache[8] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                          label: _withCtx(() => [
                            _hoisted_24,
                            _createVNode(_component_a_popover, {
                              placement: "top",
                              title: "Incidência na Base de Cálculo IPI"
                            }, {
                              content: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedIncidenciasCalculo, (incidencia, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: incidencia.incidencia + index
                                  }, [
                                    (incidencia.incidencia === 'IPI')
                                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                          key: 0,
                                          style: {"margin-left":"0px!important"},
                                          checked: incidencia.valor,
                                          "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.totalAlterado()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacoes-fp"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoIpiTotal,
                              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.computedImpostos.baseCalculoIpiTotal) = $event)),
                              onValorDigitado: _cache[11] || (_cache[11] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do IPI",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorIpiTotal,
                              "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.computedImpostos.valorIpiTotal) = $event)),
                              onValorDigitado: _cache[13] || (_cache[13] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_a_form_item, {
                          label: "BC da Importação",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoImportacaoTotal,
                              "onUpdate:valor": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.computedImpostos.baseCalculoImportacaoTotal) = $event)),
                              onValorDigitado: _cache[15] || (_cache[15] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor da Importação",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorImportacaoTotal,
                              "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.computedImpostos.valorImportacaoTotal) = $event)),
                              onValorDigitado: _cache[17] || (_cache[17] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                          label: _withCtx(() => [
                            _hoisted_40,
                            _createVNode(_component_a_popover, {
                              placement: "top",
                              title: "Incidência na Base de Cálculo PIS"
                            }, {
                              content: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedIncidenciasCalculo, (incidencia, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: incidencia.incidencia + index
                                  }, [
                                    (incidencia.incidencia === 'PIS')
                                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                          key: 0,
                                          style: {"margin-left":"0px!important"},
                                          checked: incidencia.valor,
                                          "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                          onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.totalAlterado()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacoes-fp"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoPisTotal,
                              "onUpdate:valor": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.computedImpostos.baseCalculoPisTotal) = $event)),
                              onValorDigitado: _cache[20] || (_cache[20] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do PIS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorPisTotal,
                              "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.computedImpostos.valorPisTotal) = $event)),
                              onValorDigitado: _cache[22] || (_cache[22] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                          label: _withCtx(() => [
                            _hoisted_48,
                            _createVNode(_component_a_popover, {
                              placement: "top",
                              title: "Incidência na Base de Cálculo COFINS"
                            }, {
                              content: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedIncidenciasCalculo, (incidencia, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: incidencia.incidencia + index
                                  }, [
                                    (incidencia.incidencia === 'COFINS')
                                      ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                          key: 0,
                                          style: {"margin-left":"0px!important"},
                                          checked: incidencia.valor,
                                          "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                          onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.totalAlterado()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["checked", "onUpdate:checked"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacoes-fp"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.baseCalculoCofinsTotal,
                              "onUpdate:valor": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.computedImpostos.baseCalculoCofinsTotal) = $event)),
                              onValorDigitado: _cache[25] || (_cache[25] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor do COFINS",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorCofinsTotal,
                              "onUpdate:valor": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.computedImpostos.valorCofinsTotal) = $event)),
                              onValorDigitado: _cache[27] || (_cache[27] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor total do ICMS Desonerado",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorIcmsDesoneradoTotal,
                              "onUpdate:valor": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.computedImpostos.valorIcmsDesoneradoTotal) = $event)),
                              onValorDigitado: _cache[29] || (_cache[29] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_card, { class: "ss-margin-totalizadores" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor aproximado dos tributos",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              quantidadeCasasDecimais: 2,
                              monetario: true,
                              valor: _ctx.computedImpostos.valorAproximadoTributosTotal,
                              "onUpdate:valor": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.computedImpostos.valorAproximadoTributosTotal) = $event)),
                              onValorDigitado: _cache[31] || (_cache[31] = ($event: any) => (_ctx.totalAlterado())),
                              disabled: !_ctx.props.editavel
                            }, null, 8, ["valor", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}